import Menus from "../Menus";

const HelpTopicAnnulations = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Vos inscriptions", link: '/topics/inscription'},
    { label: 'Annulations', link: '/topics/inscription/annulations'},
  ]

  const multiMenus = [
    {title: null, filter: 'HelpTopicAnnulations'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicAnnulations